export default __webpack_public_path__ + "static/card-7-574093d262d9333eba67f168624553fa.png";